import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Paper from "Components/UI/Paper";
import { AccountChartForm } from "Components/AccountCharts/AccountChartForm";
import { useAccountCharts } from "Context/AccountCharts";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function AccountChartCard() {
  const { openSuccess, openError } = usePopupNotificationContext();
  const { getAccountChartById, updateAccountChart } = useAccountCharts();
  const { accountChartId } = useParams();
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    AccountNumber: "",
    CreateTime: "",
    Id: 0,
    Name: "",
    ParseMessage: "",
    ParseStatus: 0,
    ExportedAccountNumber: "",
    ExportedAccountName: "",
    Export: 0,
    SweName: "",
    SystemStatus: "",
    Title: "",
    VAT: 0,
  });

  useEffect(() => {
    const asyncFetchAccountChart = async () => {
      const accountChart = await getAccountChartById(accountChartId);
      setFormData(accountChart);
    };
    asyncFetchAccountChart();
  }, [accountChartId]);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const handleUpdate = async () => {
    const res = await updateAccountChart(formData.Id, formData);

    if (res.status === 201) {
      setFormData(res.data);
      openSuccess(res.StatusText ? res.StatusText : "Uppdaterad!", 3000);
    } else {
      openError(res.StatusText ? res.StatusText : "Error!", 3000);
    }
  };

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Kontodiagram - {formData.Id}
          </Typography>
        </Box>
        <AccountChartForm
          formData={formData}
          FORM_MODE={editMode ? "EDIT" : "LOCKED"}
          handleInputChange={handleInputChange}
        />

        <Grid
          item
          xs={12}
          sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
        >
          {editMode ? (
            <>
              <Button
                size="small"
                onClick={() => setEditMode(false)}
                sx={{ ml: 1, display: editMode ? "block" : "none" }}
              >
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => {
                  handleUpdate();
                  setEditMode(false);
                }}
                sx={{ ml: 2 }}
                variant="contained"
              >
                Spara
              </Button>
            </>
          ) : (
            <>
              <Button size="small" onClick={() => navigate(-1)}>
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => setEditMode(true)}
                variant="contained"
                sx={{ ml: 2, display: editMode ? "none" : "block" }}
              >
                Editera
              </Button>
            </>
          )}
        </Grid>
      </Paper>
    </>
  );
}
